// extracted by mini-css-extract-plugin
export default {"tableRoot":"ChatsTable_tableRoot__xkj2W","lensHeadCell":"ChatsTable_lensHeadCell__78KKS"};